var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 87,
    viewBox: "0 0 94 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3784 45.1899C73.0034 57.0649 64.0496 68.2464 51.4859 70.7449C45.3583 71.9652 39.002 71.2212 33.3219 68.6188C27.6418 66.0164 22.9276 61.6883 19.8504 56.2507C16.7732 50.8132 15.49 44.5434 16.1835 38.3341C16.8769 32.1248 19.5117 26.2926 23.7126 21.6679C32.3291 12.1774 46.8784 9.56491 58.7534 14.3149",
    stroke: "#00A573",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0034 40.4414L46.8784 52.3164L75.3784 21.4414",
    stroke: "#00A573",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/check-success.ee94bacf3d042c73b4ea126d627c82c4.svg";
export { ForwardRef as ReactComponent };